const Navbar = () => {
    return <div className='col-[2_/_3] py-[15px]'>
        {/* <div className='w-[90px]'>
            <img className='object-cover aspect-auto w-full' src='/assets/logo.png' alt='logo'/>
        </div> */}

    </div>
}

export default Navbar
